import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import NavBar from '../NavBar/navbar';
import axios from 'axios';
import { useRoutes } from 'hookrouter';
import Routes from '../routes/routes';
import { Collapse, Dialog, DialogContent, IconButton, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import { v4 as uuidv4 } from 'uuid';
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';

import Pagination from '@material-ui/lab/Pagination';
import SearchIcon from '@material-ui/icons/Search';
import DownloadIcon from '@material-ui/icons/GetApp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import AddIcon from '@material-ui/icons/Add';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Slider from '@material-ui/core/Slider';
import { setDistanceSelector } from '../../services/searchSlice';
import { useDispatch, useSelector } from 'react-redux';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import YAML from 'json2yaml';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import { GridCloseIcon } from '@material-ui/data-grid';
import { SEARCH_TYPE } from '../../utils/constants';
import { PlaceAutocompleteClassic } from '../AddressGoogleMaps/PlaceAutoCompleteClassic';
import { APIProvider } from '@vis.gl/react-google-maps';
import SearchMap from '../AddressGoogleMaps/SearchMap';
import { setCustomerSelector } from '../../services/homeSlice';
import AddressTableView from '../AddressGoogleMaps/AddressTableView';

const API_KEY = "AIzaSyCvOQLQzL6EoVq6Kh8z6V3CE0HnoXKspfk"


export const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: '20px',
    '& .MuiFormControl-root': {
      width: '80%',
      textAlign: 'left',
      padding: '0',
    },
  },

  tooltip: {
    fontSize: '1em',
  },
  header: {
    marginTop: '20%',
    textAlign: 'center',
    marginBottom: '20px',
    color: '#023047',
  },
  searchHeader: {
    marginLeft: '30px',
    marginTop: '10px',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  infoSpan: {
    color: 'indianred',
    left: '10px',
    position: 'absolute',
    transform: 'translateY(10%)',
    fontSize: '16px',
  },
  infoSpan2: {
    color: 'indianred',
    left: '10px',
    position: 'absolute',
    transform: 'translateY(90%)',
    fontSize: '16px',
  },
  chips: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: 0,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  container: {
    maxHeight: '65vh',
    marginTop: theme.spacing(1),
  },
  accordion: {
    textAlign: 'left',
  },
  content: {
    overflow: 'auto',
  },
  wrap: {
    margin: theme.spacing(1),
    padding: theme.spacing(1),
  },
  btninside: {
    margin: theme.spacing(0),
    marginLeft: '5px',
    height: '54px',
  },
  boxWrap: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  slider: {
    width: 300,
    textAlign: 'center',
    margin: '0 auto',
    marginTop: '10px',
  },

  columnDividerLeftIndication: {
    position: 'absolute',
    top: 0,
    right: 0,
    transform: 'translate(00px, 16px)',
  },

  columnDividerRightIndication: {
    position: 'absolute',
    top: 0,
    left: 0,
    transform: 'translate(-10px, 16px)',
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function Search(props) {
  const dispatch = useDispatch();
  useRoutes(Routes);

  const [query, setQuery] = useState({ text: '' });
  const [customerID, setCustomerID] = useState(null);
  const [categories, setCategories] = useState([]);
  const [currentCategory, setCurrentCategory] = useState('All');
  const api = '/api/';
  const classes = useStyles();
  const [searchResult, setSearchResult] = useState([]);
  const [chipData, setchipData] = useState([]);
  const [labels, setlabels] = useState([]);
  const [instances, setinstances] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState([]);
  const [open, setOpen] = useState('');
  const [error, seterror] = useState(false);
  const [isZip, setisZip] = useState(false);
  const [isAddress, setisAddress] = useState(false);
  const [currentMile, setcurrentMile] = useState(0);
  const [defaultZipSelection, setDefaultZipSelection] = useState(null);
  const [searchedAddress, setSearchedAddress] = useState(null);
  const [resultLimit, setResultLimit] = useState(null);
  const [mapView, setMapView] = useState(false);
  const [type, setType] = useState('Normal');
  const [sortColumn, setsortColumn] = useState('');
  const [sortType, setsortType] = useState('DESC');
  const [sortstates, setsortstates] = useState({});
  const [centralZip, setcentralZip] = useState('');
  const [previousSortColumn, setpreviousSortColumn] = useState('');
  const [suggestedZip, setsuggestedZip] = useState('');
  const [fullWidthColumns, setFullWidthColumns] = useState([]);
  const [customerNotes, setCustomerNotes] = useState(null);
  const [showNotes, setShowNotes] = useState(false);
  const [sliderIntervals, setsliderIntervals] = useState([
    {
      value: 0,
      label: '0 miles',
    },
    {
      value: 25,
      label: '25 miles',
    },
    {
      value: 50,
      label: '50 miles',
    },
    {
      value: 75,
      label: '75 miles',
    },
    {
      value: 100,
      label: '100 miles',
    },
  ]);
  const [snackopen, setsnackOpen] = React.useState(false);
  const [snackMessage, setSnackMessage] = useState('');

  const distanceResponse = useSelector(setDistanceSelector);

  const handleClick = () => {
    setSnackMessage('Copied to clipboard!');
    setsnackOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setsnackOpen(false);
    setSnackMessage('');
  };

  const handlePageChange = (event, value) => {
    setLoading(true);
    var ids = [];
    for (var i = (value - 1) * 10; i < (value - 1) * 10 + 10; i++) {
      if (searchResult[i] != undefined) {
        ids.push(searchResult[i]);
      }
    }
    if (ids.length === 0) {
      setLoading(false);
    } else {
      getIndividualInstance(ids);
    }
    setPage(value);
  };

  useEffect(() => {
    if (labels.length === 0) {
      setcentralZip('');
    }
  }, [labels]);

  const handleDelete = (key, name) => {
    setCurrentCategory('All');
    setPage(1);
    setLoading(true);
    var tempList = chipData;
    var labelList = labels;
    var index = -1;
    var filteredObj = tempList.find(function (item, i) {
      if (item.id === key) {
        index = i;
        return i;
      }
    });
    if (name.split(':').length > 2) {
      setcentralZip('');
    }
    console.log('Name: ' + name);
    labelList.splice(labelList.indexOf(name), 1);
    tempList.splice(index, 1);
    setchipData(tempList);
    updateData();
  };

  const deleteChipWithLabel = (currentlabel) => {
    setLoading(true);
    var tempList = chipData;
    var labelList = labels;
    var currentsortColumn = sortColumn;
    for (let i = 0; i < tempList.length; i++) {
      if (tempList[i].label.split(':').length > 2) {
        let key = tempList[i].label.split(':')[2].split(' ')[2];
        if (key === 'Miles') {
          setcentralZip(tempList[i].label.split(':')[1].replace(/(^\s+|\s+$)/g, ''));
          tempList.splice(i, 1);
          labelList.splice(i, 1);
        }
      }
    }
    if (
      currentlabel.split(':').length > 2 &&
      currentlabel.split(':')[1].replace(/(^\s+|\s+$)/g, '') === ''
    ) {
      setLoading(false);
      return;
    } else if (currentlabel.split(':').length > 2) {
      setcentralZip(currentlabel.split(':')[1].replace(/(^\s+|\s+$)/g, ''));
    }
    if (currentlabel in labelList) {
      console.log(true);
    }
    tempList.push({
      id: uuidv4(),
      label: currentlabel,
    });
    if (sortstates.length !== 0) {
      if (previousSortColumn in sortstates) {
        sortstates[previousSortColumn] = 'DESC';
      }
    }
    setsortColumn(currentsortColumn);
    setlabels(labelList);
    setchipData(tempList);
    updateData();
  };

  const resetChipWithLabel = (currentlabel) => {
    setLoading(true);
    var tempList = chipData;
    tempList.splice(0, tempList.length);
    var labelList = labels;
    labelList.splice(0, labelList.length);
    var currentsortColumn = sortColumn;
    for (let i = 0; i < tempList.length; i++) {
      if (tempList[i].label.split(':').length > 2) {
        let key = tempList[i].label.split(':')[2].split(' ')[2];
        if (key === 'Miles') {
          setcentralZip(tempList[i].label.split(':')[1].replace(/(^\s+|\s+$)/g, ''));
          tempList.splice(i, 1);
          labelList.splice(i, 1);
        }
      }
    }
    if (
      currentlabel.split(':').length > 2 &&
      currentlabel.split(':')[1].replace(/(^\s+|\s+$)/g, '') === ''
    ) {
      setLoading(false);
      return;
    } else if (currentlabel.split(':').length > 2) {
      setcentralZip(currentlabel.split(':')[1].replace(/(^\s+|\s+$)/g, ''));
    }
    if (currentlabel in labelList) {
      console.log(true);
    }
    tempList.push({
      id: uuidv4(),
      label: currentlabel,
    });
    if (sortstates.length !== 0) {
      if (previousSortColumn in sortstates) {
        sortstates[previousSortColumn] = 'DESC';
      }
    }
    setsortColumn(currentsortColumn);
    setlabels(labelList);
    setchipData(tempList);
    updateData();
  };

  const handleAddressSearch = (place) => {
    if (place === null) {
      return;
    }

    setType('Address');
    setSearchedAddress(place);
    setchipData([place])
  }

  const handleAddressSearchNormalView = (place) => {

    if (place === null) {
      return;
    }

    setType('Address');
    setSearchedAddress(place);
    setchipData([place])

    setLoading(true);
    setchipData(["placeName"])
  }

  const handleSearch = (type) => {
    if (type === 'Zip' && query.text === '') {
      return;
    }

    setLoading(true);
    let currentLabel;

    if (type === 'Normal') {
      setType('Normal');
      if (query.text === '') {
        currentLabel = currentCategory + ': '.replace(/(^\s+|\s+$)/g, '');
      } else {
        currentLabel = (currentCategory + ': ' + query.text.toLowerCase()).replace(
          /(^\s+|\s+$)/g,
          '',
        );
      }
      if (!labels.includes(currentLabel)) {
        let current = chipData;
        current.push({
          id: uuidv4(),
          label: currentLabel,
        });
        setchipData(current);
        setQuery(Object.freeze({ text: '' }));
        labels.push(currentLabel);
        setPage(1);
        updateData();
      } else {
        setQuery(Object.freeze({ text: '' }));
        setLoading(false);
      }
    } else if (type === 'Zip') {
      setType('Zip');
      setcentralZip(query.text);
      currentLabel = (currentCategory + ': ' + query.text + ': ' + currentMile + ' Miles').replace(
        /(^\s+|\s+$)/g,
        '',
      );
      setPage(1);
      deleteChipWithLabel(currentLabel);
    }
  };

  const handleResetSearch = (type) => {
    if (type === 'Zip' && query.text === '') {
      return;
    }

    setLoading(true);
    let currentLabel;

    if (type === 'Normal') {
      setType('Normal');
      if (query.text === '') {
        currentLabel = currentCategory + ': '.replace(/(^\s+|\s+$)/g, '');
      } else {
        currentLabel = (currentCategory + ': ' + query.text.toLowerCase()).replace(
          /(^\s+|\s+$)/g,
          '',
        );
      }

      let current = chipData;
      current.splice(0, current.length);
      current.push({
        id: uuidv4(),
        label: currentLabel,
      });
      setchipData(current);
      setQuery(Object.freeze({ text: '' }));
      labels.splice(0, labels.length);
      labels.push(currentLabel);
      setPage(1);
      updateData();
    } else if (type === 'Zip') {
      setType('Zip');
      setcentralZip(query.text);
      currentLabel = (currentCategory + ': ' + query.text + ': ' + currentMile + ' Miles').replace(
        /(^\s+|\s+$)/g,
        '',
      );
      setPage(1);
      resetChipWithLabel(currentLabel);
    }
  };

  useEffect(() => {
    for (let i = 0; i < categories.length; i++) {
      if (categories[i].name === currentCategory && categories[i].type.name === 'Zip Code') {
        setisZip(true);
        break;
      } else {
        setisZip(false);
      }

      if (categories[i].name === currentCategory && categories[i].type.name === 'Address') {
        setisAddress(true);
        break;
      } else {
        setisAddress(false);
      }
    }
  }, [currentCategory]);

  useEffect(() => {
    setCustomerID(props.customerID);
    if (customerID) {
      let categoryUrl = api + 'templateattribute/active/category/v3/?customerId=' + customerID;
      if (props.templateId) {
        categoryUrl += '&templateId=' + props.templateId;
      }
      axios
        .get(categoryUrl)
        .then((response) => {
          var jsonResponse = response.data;
          if (jsonResponse.length === 0) {
            return;
          }
          var sortedResponse = jsonResponse.sort(function (a, b) {
            return compareStrings(a.name, b.name);
          });
          var defaultCategories = jsonResponse.filter((item) => item.isDefault);
          if (categories.length === 0) setCategories(sortedResponse);
          if (defaultCategories.length != 0) {
            console.log(defaultCategories[0].name);
            setCurrentCategory(defaultCategories[0].name);
          }
        })
        .catch((error) => {
          console.log('Fetch data types error');
        });
    }
  }, [customerID, categories]);

  useEffect(() => {
    if (customerID) {
      axios.get(api + 'customer/' + customerID).then((response) => {
        if (response?.data?.notes) {
          setCustomerNotes(response.data.notes);
          setShowNotes(true);
        }
        if (response?.data?.defaultZipSelection !== null) {
          setDefaultZipSelection(parseInt(response.data.defaultZipSelection));
          setcurrentMile(parseInt(response.data.defaultZipSelection));
        }
        if (response?.data?.resultLimit !== null) {
          setResultLimit(response.data.resultLimit);
        }
        if (response?.data?.mapView !== null) {
          setMapView(response.data.mapView);
        }
      });
    }
  }, [customerID]);

  function compareStrings(a, b) {
    a = a.toLowerCase();
    b = b.toLowerCase();

    return a < b ? -1 : a > b ? 1 : 0;
  }

  function handleChange(event) {
    const newQuery = Object.freeze({ text: event.target.value });
    setQuery(newQuery);
  }

  useEffect(() => {
    var ids = [];
    setLoading(true);
    if (searchResult.length !== 0) {
      for (var i = 0; i < 10; i++) {
        if (searchResult[i] !== undefined) {
          ids.push(searchResult[i]);
        }
      }
      setLoading(true);
      getIndividualInstance(ids);
    } else {
      setinstances([]);
      setLoading(false);
    }
  }, [searchResult]);

  function updateData(state = null) {
    let data = [];
    let scaffold = {};
    if (props.templateId) {
      scaffold['templateId'] = props.templateId;
    }
    if (chipData.length !== 0) {
      chipData.map((value) => {
        let val = value.label;
        let mappingArray = val.split(':');

        if (mappingArray.length > 2) {
          let key = mappingArray[0];
          let value = mappingArray[2].split(' ');
          setcentralZip(mappingArray[1].replace(/(^\s+|\s+$)/g, ''));
          let mile = value[1];
          data.push({
            attributeName: key.replace(/(^\s+|\s+$)/g, ''),
            searchString: mappingArray[1].replace(/(^\s+|\s+$)/g, ''),
            isGlobal: false,
            zipRadius: mile,
          });
        } else {
          let key = mappingArray[0];
          if (key === 'All') {
            data.push({
              attributeName: key.replace(/(^\s+|\s+$)/g, ''),
              searchString: mappingArray[1].replace(/(^\s+|\s+$)/g, '').toLowerCase(),
              isGlobal: true,
            });
          } else {
            data.push({
              attributeName: key.replace(/(^\s+|\s+$)/g, ''),
              searchString: mappingArray[1].replace(/(^\s+|\s+$)/g, '').toLowerCase(),
              isGlobal: false,
            });
          }
          return 0;
        }
      });

      if (sortColumn === '') {
        scaffold['attributeSearchItems'] = data;
      } else {
        scaffold['attributeSearchItems'] = data;
        if (state != null) {
          scaffold['sortInfo'] = {
            sortByAttributeName: state,
            sortOrder: sortstates[state],
          };
        }
      }
    } else {
      setSearchResult([]);
      setcurrentMile(defaultZipSelection || 0);
      setQuery(Object.freeze({ text: '' }));
      setisZip(false);
    }

    let url = api + 'instance/search/category/multiple/v4/' + customerID;
    if (isAddress && !mapView) {
      url = api + 'address/search/compact/' + customerID;
    }

    axios
      .post(url, scaffold, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        setsuggestedZip(response.data.zipCodeChange);

        if (response.data.instanceIds.length === 0) {
          setSearchResult([]);
          return;
        }
        console.log(response.data.instanceIds);
        if (!resultLimit) setSearchResult(response.data.instanceIds);
        else setSearchResult(response.data.instanceIds.slice(0, resultLimit));
      })
      .catch((error) => {
        console.log(error);
        setSearchResult([]);
        return;
      });
  }

  function getIndividualInstance(id) {
    axios
      .get(api + 'instanceattribute/forinstance/multiple?instanceIds=' + id)
      .then((response) => {
        console.log(id);
        var tempInstance = [];
        var jsonResponse = response.data;
        var attributes = [];
        var result = {};
        var collapse = [];
        let final = [];
        let zips = [];
        let attrNameForZip = '';
        for (var ele of id) {
          attributes.push(jsonResponse.filter((value) => value.instance.id == ele));
        }
        var i = 0;
        while (i < attributes.length) {
          var names = [];
          var orderLookup = {};
          for (var val of attributes[i]) {
            let attr = val.templateAttribute.type.name == 'Zip Code' ? true : null;
            if (attr !== null && attrNameForZip === '') {
              attrNameForZip = val.templateAttribute.name;
              console.log(attrNameForZip);
            }
            names.push(val.templateAttribute.name);
            orderLookup[val.templateAttribute.name] = val.templateAttribute.order;
            result[val.templateAttribute.name] = val.content;
            result['id'] = val.id;
            if (
              val.templateAttribute.type.name == 'Zip Code' &&
              val.content != null &&
              val.content !== undefined &&
              val.content !== ''
            ) {
              zips.push(val.content);
            }
          }
          i++;
          final.push(result);
          result = {};
        }
        console.log('Zips: ' + zips);
        console.log(names.length, Object.keys(orderLookup).length, names, orderLookup);
        if (names.length == Object.keys(orderLookup).length)
          names = names.sort((i, j) => orderLookup[i] - orderLookup[j]);
        else names = names.sort();
        names = names.filter((item) => item !== attrNameForZip);
        if (sortColumn === '') {
          setsortColumn(names[0]);
          setpreviousSortColumn(names[0]);
        }

        if (attributes.length !== 0) {
          if (centralZip !== '' && zips.length !== 0) {
            console.log('empty');
            names.unshift('Distance from ' + centralZip + ' to ZIP');
            if (attrNameForZip) names.unshift(attrNameForZip);
            axios
              .post(
                api + 'zipservice/distancelist/?center=' + centralZip + '&zipList=' + zips,
                {},
                {
                  headers: {
                    'Content-Type': 'application/json',
                  },
                },
              )
              .then((response) => {
                let distances = response.data;
                console.log(distances);
                for (let i = 0; i < final.length; i++) {
                  final[i]['Distance from ' + centralZip + ' to ZIP'] =
                    distances[i] === 0 ? 0 + ' Miles' : distances[i].toFixed(2) + ' Miles';
                }
                zips = [];
                setLoading(false);
                setOpen(collapse);
                setTimeout(() => {
                  setColumns(names);
                  setinstances(final);
                }, 100);
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            if (isZip === true) {
              setcentralZip(query.text);
            }
            if (attrNameForZip) names.unshift(attrNameForZip);
            setLoading(false);
            setOpen(collapse);
            setTimeout(() => {
              setColumns(names);
              setinstances(final);
            }, 100);
          }
        } else {
          if (attrNameForZip) names.unshift(attrNameForZip);
          setLoading(false);
          setOpen(collapse);
          setTimeout(() => {
            setColumns(names);
            setinstances(final);
          }, 100);
        }
      })
      .catch((error) => {
        console.log(error);
        console.log('Fetch instances error');
      });
  }

  useEffect(() => {
    console.log(centralZip);
  }, [centralZip]);

  const copyToClipboard = (row, columns) => {
    var jsonObject = {};
    columns.map((column) => (jsonObject[column] = row[column]));
    console.log(jsonObject);
    const ta = document.createElement('textarea');
    ta.innerText = YAML.stringify(jsonObject);
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    ta.remove();
    jsonObject = {};
    handleClick();
  };

  const copyText = (text) => {
    const ta = document.createElement('textarea');
    if (!text) return;
    ta.innerText = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    ta.remove();
    handleClick();
  };

  const toggleFullWidthColumns = (column) => {
    let currentFullWidthColumns = [...fullWidthColumns];
    if (currentFullWidthColumns.includes(column)) {
      currentFullWidthColumns.splice(currentFullWidthColumns.indexOf(column), 1);
    } else {
      currentFullWidthColumns.push(column);
    }

    setFullWidthColumns(currentFullWidthColumns);
  };

  function search(event, key, type) {
    if (event.key === 'Enter') {
      let currentLabel;
      setLoading(true);
      if (type === 'Normal') {
        setType('Normal');
        if (query.text === '' || query.text.toLowerCase() === 'full list') {
          currentLabel = currentCategory + ': '.replace(/(^\s+|\s+$)/g, '');
        } else {
          currentLabel = (currentCategory + ': ' + query.text.toLowerCase()).replace(
            /(^\s+|\s+$)/g,
            '',
          );
        }
        if (!labels.includes(currentLabel)) {
          let current = chipData;
          chipData.splice(0, chipData.length);
          current.push({
            id: key,
            label: currentLabel,
          });
          if (sortstates.length !== 0) {
            if (previousSortColumn in sortstates) {
              sortstates[previousSortColumn] = 'DESC';
            }
          }
          console.log(current);
          setchipData(current);
          setQuery(Object.freeze({ text: '' }));
          event.target.value = '';
          labels.splice(0, labels.length);
          labels.push(currentLabel);
          updateData();
        } else {
          setQuery(Object.freeze({ text: '' }));
          setLoading(false);
          event.target.value = '';
        }
      } else if (type === 'Zip') {
        if (query.text !== centralZip) {
          setcentralZip(query.text);
        }
        setType('Zip');
        currentLabel = (
          currentCategory +
          ': ' +
          centralZip +
          ': ' +
          currentMile +
          ' Miles'
        ).replace(/(^\s+|\s+$)/g, '');
        setQuery(Object.freeze({ text: '' }));
        event.target.value = '';
        resetChipWithLabel(currentLabel);
      }
    }
  }

  return (
    <>
      <NavBar />
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={showNotes}>
        <Alert severity="info">
          <AlertTitle style={{ textAlign: 'left' }}>
            <span style={{ textAlign: 'left' }}>Notes</span>
            <Button
              style={{ position: 'absolute', right: '10px' }}
              onClick={() => setShowNotes(false)}
            >
              <GridCloseIcon fontSize="small" style={{ color: 'white' }}></GridCloseIcon>
            </Button>
          </AlertTitle>
          <div
            style={{
              textAlign: 'left',
              maxWidth: '300px',
              minWidth: '300px',
              overflowWrap: 'break-word',
              maxHeight: '350px',
              overflowY: 'auto',
              whiteSpace: 'pre-line',
            }}
          >
            {customerNotes}
          </div>
        </Alert>
      </Snackbar>
      <div>
        {chipData.length == 0 && (
          <Box>
            <Typography variant="h2" className={classes.header}>
              Link Search
            </Typography>
            <Grid container spacing={0} className={classes.root}>
              <Grid item md={2} sm={12} xs={12}></Grid>
              <Grid item md={2} sm={12} xs={12}>
                <TextField
                  select
                  name="type"
                  value={currentCategory}
                  variant="outlined"
                  onChange={(event) => setCurrentCategory(event.target.value)}
                >
                  <MenuItem value="All">All</MenuItem>
                  {categories.map((each) => (
                    <MenuItem value={each.name}>{each.name}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item md={6} sm={12} xs={10}>
                {!isZip && !isAddress && (
                  <>
                    <TextField
                      id="standard-basic"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      placeholder="Enter your search terms here...."
                      onKeyUp={(e) => search(e, uuidv4(), 'Normal')}
                      onChange={handleChange}
                    />
                    <Button
                      variant="contained"
                      size="large"
                      color="primary"
                      className={classes.btninside}
                      onClick={() => handleSearch('Normal')}
                    >
                      <SearchIcon />{' '}
                    </Button>
                  </>

                )}
                {isAddress && (
                  <Grid style={{ marginLeft: "2.6rem" }}>
                    <APIProvider apiKey={API_KEY}>
                      <PlaceAutocompleteClassic onPlaceSelect={(place) => {

                        if (!place?.formatted_address) {
                          return;
                        }

                        if (mapView) {
                          handleAddressSearch(place)
                        } else {
                          handleAddressSearchNormalView(place)
                        }
                      }} />
                    </APIProvider>
                    {/* <Button
                      variant="contained"
                      size="large"
                      color="primary"
                      className={classes.btninside}
                      onClick={() => handleSearch('Addres')}
                    >
                      <SearchIcon />{' '}
                    </Button> */}
                  </Grid>
                )}
                {isZip && (
                  <>
                    <TextField
                      type="number"
                      variant="outlined"
                      defaultValue={query.text}
                      InputProps={{
                        inputProps: {
                          max: 99999,
                          min: 10000,
                          maxLength: 5,
                        },
                      }}
                      error={error}
                      onKeyUp={(e) => {
                        if (
                          e.target.value.length > 5 ||
                          e.target.value.length === 0 ||
                          e.target.value.length < 5
                        ) {
                          seterror(true);
                        } else {
                          setcentralZip(e.target.value);
                          seterror(false);
                          search(e, uuidv4(), 'Zip');
                        }
                      }}
                      onChange={handleChange}
                      placeholder="Enter Zip Code"
                      label="Zip code"
                    />
                    <Button
                      variant="contained"
                      size="large"
                      color="primary"
                      className={classes.btninside}
                      onClick={() => {
                        if (!error) {
                          handleSearch('Zip');
                        }
                      }}
                    >
                      <SearchIcon />
                    </Button>
                  </>
                )}
                {searchResult && searchResult.length ? (
                  <Button
                    variant="container"
                    size="large"
                    color="primary"
                    className={classes.btninside}
                  >
                    <DownloadIcon />
                  </Button>
                ) : null}

                <ul className={classes.chips}>
                  {chipData.map((data) => (
                    <li key={data.id}>
                      <Chip
                        label={data.label}
                        onDelete={(e) => handleDelete(data.id, data.label)}
                        className={classes.chip}
                      />
                    </li>
                  ))}
                </ul>
              </Grid>

              <Grid item md={2} sm={12} xs={12}></Grid>
            </Grid>
            {isZip === true && defaultZipSelection === null && (
              <div className={classes.slider}>
                <Typography id="discrete-slider-restrict" gutterBottom>
                  Selection radius
                </Typography>
                <Slider
                  defaultValue={currentMile}
                  aria-labelledby="discrete-slider-restrict"
                  step={null}
                  max="100"
                  onChangeCommitted={(event, value) => {
                    setcurrentMile(value);
                    setPage(1);
                  }}
                  valueLabelDisplay="auto"
                  marks={sliderIntervals}
                />
              </div>
            )}
          </Box>
        )}

        {chipData.length !== 0 && !isAddress && (
          <Box>
            <Grid container spacing={2} className={classes.root}>
              <Grid item md={2} sm={12} xs={12}>
                <Typography variant="h5" className={classes.searchHeader}>
                  Link Search
                </Typography>
              </Grid>
              <Grid item md={2} sm={12} xs={12}>
                <TextField
                  select
                  name="type"
                  value={currentCategory}
                  variant="outlined"
                  onChange={(event) => setCurrentCategory(event.target.value)}
                >
                  <MenuItem value="All">All</MenuItem>
                  {categories.map((each) => (
                    <MenuItem value={each.name}>{each.name}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item md={7} sm={12} xs={12}>
                {isZip === false && (
                  <TextField
                    id="standard-basic"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={query?.text || ''}
                    placeholder="Enter your search terms here...."
                    onKeyUp={(e) => search(e, uuidv4(), 'Normal')}
                    onChange={handleChange}
                  />
                )}
                {isZip === true && (
                  <>
                    <TextField
                      type="number"
                      variant="outlined"
                      InputProps={{
                        inputProps: {
                          max: 99999,
                          min: 10000,
                        },
                      }}
                      error={error}
                      onKeyUp={(e) => {
                        if (
                          e.target.value.length > 5 ||
                          e.target.value.length === 0 ||
                          e.target.value.length < 5
                        ) {
                          seterror(true);
                        } else {
                          setcentralZip(e.target.value);
                          seterror(false);
                          search(e, uuidv4(), 'Zip');
                        }
                      }}
                      onChange={handleChange}
                      placeholder="Enter Zip Code"
                      label="Zip code"
                    />
                  </>
                )}
                {isZip === false && (
                  <Tooltip title="" classes={{ tooltip: classes.tooltip }}>
                    <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      className={classes.btninside}
                      onClick={() => handleResetSearch('Normal')}
                    >
                      <SearchIcon />{' '}
                    </Button>
                  </Tooltip>
                )}
                {isZip === true && (
                  <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    className={classes.btninside}
                    onClick={() => {
                      if (!error) {
                        handleResetSearch('Zip');
                      }
                    }}
                  >
                    <SearchIcon />
                  </Button>
                )}
                {isZip === false && (
                  <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    title="Add additional search criteria"
                  >
                    <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      className={classes.btninside}
                      onClick={() => handleSearch('Normal')}
                    >
                      <AddIcon />{' '}
                    </Button>
                  </Tooltip>
                )}
                {isZip === true && (
                  <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    title="Add additional search criteria"
                  >
                    <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      className={classes.btninside}
                      onClick={() => {
                        if (!error) {
                          handleSearch('Zip');
                        }
                      }}
                    >
                      <AddIcon />
                    </Button>
                  </Tooltip>
                )}
                {isZip === true && defaultZipSelection === null && (
                  <div className={classes.slider}>
                    <Typography id="discrete-slider-restrict" gutterBottom>
                      Selection radius
                    </Typography>
                    <Slider
                      defaultValue={currentMile}
                      aria-labelledby="discrete-slider-restrict"
                      step={null}
                      max="100"
                      onChangeCommitted={(event, value) => {
                        if (query.text !== centralZip) {
                          setcentralZip(query.text);
                        }
                        setLoading(true);
                        setPage(1);
                        let currentLabel = (
                          currentCategory +
                          ': ' +
                          centralZip +
                          ': ' +
                          value +
                          ' Miles'
                        ).replace(/(^\s+|\s+$)/g, '');
                        deleteChipWithLabel(currentLabel);
                        setcurrentMile(value);
                      }}
                      valueLabelDisplay="auto"
                      marks={sliderIntervals}
                    />
                  </div>
                )}

                <div>
                  <span className={classes.infoSpan}>* Click a cell to copy its contents</span>
                  <span className={classes.infoSpan2}>* Search 'Full List' to see All Results</span>
                  <ul className={classes.chips}>
                    {chipData.map((data) => (
                      <li key={data.id}>
                        <Chip
                          label={data.label}
                          onDelete={(e) => handleDelete(data.id, data.label)}
                          className={classes.chip}
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              </Grid>
            </Grid>

            <Paper className={classes.wrap} elevation={3}>
              {!loading && instances && searchResult.length === 0 && instances.length === 0
                ? 'No Data Available'
                : ''}
              <TableContainer className={classes.container}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  onClick={(e) => {
                    e?.target?.nodeName === 'TH'
                      ? toggleFullWidthColumns(e.target.innerText)
                      : copyText(e.target.innerText);
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell></TableCell>
                      {columns &&
                        searchResult.length !== 0 &&
                        columns.map((column, i) => (
                          <TableCell
                            align="left"
                            style={{
                              whiteSpace: 'nowrap',
                              cursor: 'pointer',
                              borderRight: '1px solid lightgrey',
                            }}
                            value={column}
                          >
                            {/* {(i !== 0) && <ArrowRightIcon className={classes.columnDividerRightIndication}/>} */}
                            {column}
                            {column !== 'Distance from ' + centralZip + ' to ZIP' && (
                              <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={() => {
                                  console.log(column);

                                  if (column === 'Distance from ' + centralZip + ' to ZIP') {
                                    return;
                                  }
                                  setLoading(true);
                                  let current = sortstates;
                                  let previous = previousSortColumn;
                                  setsortColumn(column);

                                  if (column in current) {
                                    if (current[column] === 'DESC') {
                                      current[column] = 'ASC';
                                    } else if (current[column] === 'ASC') {
                                      current[column] = 'DESC';
                                    }
                                  } else {
                                    current[column] = 'DESC';
                                  }

                                  if (previous !== column) {
                                    current[previousSortColumn] = 'DESC';
                                  }
                                  setpreviousSortColumn(column);

                                  setsortstates(current);
                                  setPage(1);
                                  updateData(column);
                                }}
                              >
                                {sortstates[column] === 'ASC' ? (
                                  <KeyboardArrowUpIcon style={{ fontSize: '15px' }} />
                                ) : (
                                  <KeyboardArrowDownIcon style={{ fontSize: '15px' }} />
                                )}
                              </IconButton>
                            )}
                            {/* <ArrowLeftIcon className={classes.columnDividerLeftIndication} /> */}
                            <IconButton onClick={() => toggleFullWidthColumns(column)}>
                              <CompareArrowsIcon />
                            </IconButton>
                          </TableCell>
                        ))}
                      {columns && searchResult.length !== 0 && (
                        <TableCell style={{ textAlign: 'center' }}>Copy row</TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {!loading && searchResult.length !== 0 && instances
                      ? instances.map((row) => {
                        return (
                          <>
                            <TableRow hover role="checkbox" tabIndex={-1}>
                              <TableCell>
                                <IconButton
                                  aria-label="expand row"
                                  size="small"
                                  onClick={() => setOpen(open == row.id ? '' : row.id)}
                                >
                                  {open == row.id ? (
                                    <KeyboardArrowUpIcon />
                                  ) : (
                                    <KeyboardArrowDownIcon />
                                  )}
                                </IconButton>
                              </TableCell>
                              {columns.map((column) => (
                                <TableCell
                                  align="left"
                                  style={{
                                    maxWidth: fullWidthColumns.includes(column) ? 'none' : 100,
                                    borderRight: '1px solid lightgray',
                                  }}
                                >
                                  {row !== null && row !== undefined && row !== '' ? (
                                    <Typography
                                      style={{ cursor: 'pointer' }}
                                      noWrap
                                      variant="body2"
                                    >
                                      {row[column]}
                                    </Typography>
                                  ) : (
                                    'NA'
                                  )}
                                </TableCell>
                              ))}
                              <TableCell>
                                <Button
                                  startIcon={<FileCopyIcon />}
                                  className={classes.btn}
                                  color="default"
                                  onClick={() => {
                                    copyToClipboard(row, columns);
                                  }}
                                />
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                style={{ paddingBottom: 0, paddingTop: 0 }}
                                colSpan={columns.length}
                              >
                                <Collapse in={open == row.id} timeout="auto" unmountOnExit>
                                  {columns.map((column) => (
                                    <Box>
                                      {row[column] !== null &&
                                        row[column] !== undefined &&
                                        row[column] !== '' ? (
                                        row[column].length > 15 ? (
                                          <div className={classes.boxWrap}>
                                            <Typography
                                              variant="subtitle1"
                                              style={{ fontWeight: 'bold' }}
                                            >
                                              {column}
                                            </Typography>
                                            <Typography variant="body2">{row[column]}</Typography>
                                          </div>
                                        ) : (
                                          ''
                                        )
                                      ) : (
                                        ''
                                      )}
                                    </Box>
                                  ))}
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </>
                        );
                      })
                      : ''}
                  </TableBody>
                </Table>
              </TableContainer>
              <Dialog open={loading}>
                <DialogContent style={{ overflow: 'hidden', textAlign: 'center' }}>
                  <CircularProgress />
                  <Typography variant="h6">Fetching results</Typography>
                </DialogContent>
              </Dialog>
              <Box style={{ textAlign: 'center', margin: '10px', marginLeft: '40%' }}>
                <Pagination
                  count={Math.ceil(searchResult.length / 10)}
                  page={page}
                  onChange={handlePageChange}
                />
              </Box>
            </Paper>
          </Box>
        )}

        {isAddress && searchedAddress !== null && mapView && (
          <>
            <SearchMap
              customerId={customerID}
              searchedPlace={searchedAddress}
              handleClose={() => { setSearchedAddress(null); setchipData([]); }}
              setLoading={setLoading}
            />
            <Dialog open={loading}>
              <DialogContent style={{ overflow: 'hidden', textAlign: 'center' }}>
                <CircularProgress />
                <Typography variant="h6">Fetching results</Typography>
              </DialogContent>
            </Dialog>
          </>

        )}

        {isAddress && searchedAddress !== null && !mapView && (
          <>
            <AddressTableView
              customerId={customerID}
              searchedPlace={searchedAddress}
              handleClose={() => { setSearchedAddress(null); setchipData([]); }}
              setLoading={setLoading}
            />
            <Dialog open={loading}>
              <DialogContent style={{ overflow: 'hidden', textAlign: 'center' }}>
                <CircularProgress />
                <Typography variant="h6">Fetching results</Typography>
              </DialogContent>
            </Dialog>
          </>
        )

        }




        <Snackbar open={snackopen} autoHideDuration={2000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="success">
            {snackMessage}
          </Alert>
        </Snackbar>
      </div>
    </>
  );
}
